@if (_transaction != undefined) {
  <div>
    <div
      style="
        margin-bottom: 20px;
        border: 1px solid #dddddd;
        border-radius: 8px;
        padding: 16px;
        background-color: #ffffff;
      "
    >
      <h4>Customer</h4>
      <p>
        {{ _transaction.customerFirstName }} {{ _transaction.customerLastName }}
      </p>
    </div>
    <div
      style="
        border: 1px solid #dddddd;
        border-radius: 8px;
        padding: 16px;
        background-color: #ffffff;
      "
      [showLoadingSpinner]="loading"
    >
      <h4>
        Transaction - {{ _transaction.successful ? 'Successful' : 'Failed' }}
      </h4>
      <div style="margin-bottom: 12px">
        <!--<div>{{_transaction.id}}</div>-->
        Date: {{ formatDate(_transaction.date || '') }}<br />
        Status: {{ _transaction.type }}<br />
        Amount: {{ _transaction.totalAmount }}<br />
      </div>
      <div style="margin-bottom: 12px">
        Card Type: {{ _transaction.cardType }}<br />
        Card Number: {{ _transaction.cardFirst6 }}*****{{
          _transaction.cardLast4
        }}<br />
        Card Exp: {{ _transaction.cardExpMonth }}/{{ _transaction.cardExpYear }}
      </div>
      <div>
        <!-- <input type="button" value="Begin sale reversal" class="button_secondary button_var_2 button_right-spacing" (click))="beginSaleReversal()" [hidden]="!transaction.allowReversal" /> -->
        <input
          type="button"
          value="Send Receipt"
          class="button_secondary button_var_2 button_right-spacing"
          (click)="sendTransactionToCustomer()"
        />
        <input
          type="button"
          value="Begin Transaction Return"
          class="button_secondary button_var_2 button_right-spacing"
          (click)="beginSaleReturn()"
          [hidden]="!_transaction.allowRefund || sameDayTransaction"
        />
        <input
          type="button"
          value="Begin Transaction Void"
          class="button_secondary button_var_2 button_right-spacing"
          (click)="beginSaleReturn()"
          [hidden]="!_transaction.allowRefund || !sameDayTransaction"
        />
        <input
          type="button"
          value="VOID"
          class="button_secondary button_var_2 button_right-spacing"
          (click)="beginSaleVoid()"
          [hidden]="!_transaction.allowVoid"
        />
        <input
          type="button"
          value="CAPTURE"
          class="button_secondary button_var_2"
          (click)="beginSaleCapture()"
          [hidden]="!_transaction.allowCapture"
        />
        <input
          type="button"
          value="Cancel Recurring Payment"
          class="button_secondary button_var_2"
          (click)="cancelRecurringPayment()"
          [hidden]="!canCancelRecurringPayment"
          [disabled]="disableCancelRecurringPayment"
        />
      </div>
    </div>
  </div>
}
